import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./styles.scss";

interface Props {
  name: string;
  id: string;
  placeholder?: string;
  label?: string;
  value: string | number | Date;
  dataQAId: string;
  dataElmId: string;
  onChange: (string: string) => void;
  onBlur: (string: string) => void;
  errors: Array<string>;
  disabled: boolean;
  size: string;
  className?: string;
  uppercase: boolean;
  decimals: boolean;
  maxlength: string;
  builder?: boolean;
}

class BaseNumericInput extends React.Component<Props, void> {
  render() {
    const {
      id,
      name,
      value,
      label,
      placeholder,
      dataQAId,
      dataElmId,
      children,
      errors,
      disabled,
      size,
      decimals,
      maxlength,
      builder
    } = this.props;

    let errClass = errors && errors.length ? s.error : "";
    let inputStyle = this.props.builder ? { textAlign: "right" } : {};

    return (
      <FormGroup className={s.formGroup}>
        {label && (
          <Label className={s.label} for={id}>
            {label}:
          </Label>
        )}
        <Input
          type="text"
          name={name}
          id={id}
          placeholder={placeholder}
          className={`${s.input} ${errClass} px-2 py-1 ${
            !!this.props.uppercase ? "text-uppercase" : ""
          }`}
          style={inputStyle}
          value={value}
          disabled={disabled || false}
          data-qa-id={dataQAId}
          data-elm-id={dataElmId}
          onKeyPress={event => {
            if (event.charCode == 13) {
              return event;
            }

            if (
              !(
                (event.charCode >= 48 && event.charCode <= 57) ||
                (event.charCode == 8 ||
                  event.charCode == 9 ||
                  event.charCode == 45 ||
                  event.charCode == 46)
              )
            ) {
              event.preventDefault();
            }
          }}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          size={size || "md"}
          maxlength={maxlength || ""}
        />
        {errors &&
          errors.map((message, index) => {
            return (
              <span key={index} className={s.errorSpan}>
                {message}
                <br />
              </span>
            );
          })}
      </FormGroup>
    );
  }
}

export default withStyles(s)(BaseNumericInput);
